var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 4l7.89 5.26a2 2 0 002.22 0L19 4M3 15h14a2 2 0 002-2V3a2 2 0 00-2-2H3a2 2 0 00-2 2v10a2 2 0 002 2z","stroke":"#40433E","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }